module.exports = __webpack_public_path__ + "img/d-ftop-tai.69c5224c.jpg";